import { isServer } from './util_00_env';
/**
 * 获取cookie，会对 cookie value 进行 decodeURIComponent
 * @param {string} name
 * @return {string} 返回对应的cookie值
 * @memberof module:cookie
 */

function getCookie(name) {
  if (isServer) {
    return '';
  } // const m = document.cookie.match(new RegExp(`(^| )${name}=([^;"]+)(;|$)`));
  // return !m ? '' : decodeURIComponent(m[2]);


  var m = document.cookie.match(new RegExp("(^| )".concat(name, "=([^;]*)(;|$)"), 'g'));

  if (!m) {
    return '';
  }

  var cookie;
  (m || []).some(function (i) {
    var item = i.match(new RegExp("(^| )".concat(name, "=([^;]*)(;|$)")));
    cookie = decodeURIComponent(item[2]);

    if (cookie === '""') {
      return false;
    }

    return !item ? '' : decodeURIComponent(item[2]);
  });
  return cookie;
}
/**
 * 获取cookie，会对 cookie value 进行 decodeURIComponent
 * @param {string} name
 * @memberof module:cookie
 * @return {array} 返回对应的cookie值
 * @desc 可能出现不同domain下存在相同key的cookie
 * @desc getCookie 默认取第一个, 该方法取所有的
 */


function getCookies(name) {
  if (isServer) {
    return [];
  }

  var m = document.cookie.match(new RegExp("(^| )".concat(name, "=([^;]*)(;|$)"), 'g'));
  return (m || []).map(function (i) {
    var item = i.match(new RegExp("(^| )".concat(name, "=([^;]*)(;|$)")));
    return !item ? '' : decodeURIComponent(item[2]);
  });
}
/**
 * 设置 cookie
 * @param {object} option
 * @param {string} option.name - nameof cookie
 * @param {string} option.value - value of cookie
 * @param {timestamp} option.time - expire time of cookie
 * @param {domain} option.domain - cookie目标域名
 * @memberof module:cookie
 * @example
 * imutils.setCookie({name: 'uin',value: cookies.uin,domain: '.qq.com'})
 */


function setCookie(opt) {
  if (isServer) {
    return;
  }

  var Days = 30; // 此 cookie 将被保存 30 天

  var exp = new Date(); // new Date("December 31, 9998");

  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
  var expiresTime = opt.time || exp.toGMTString();
  var domain = opt.domain || 'qq.com';
  document.cookie = "".concat(opt.name, "=").concat(encodeURIComponent(opt.value), ";expires=").concat(expiresTime, ";domain=").concat(domain, ";path=/"); // 安卓 APP 存在写入 Cookie 后关闭 WebView 失效的情况
  // 调用原生接口再写一次

  if (window.mqq && window.mqq.android) {
    window.mqq.invoke('edu', 'setCookie', {
      key: opt.name,
      value: opt.value,
      expiresTime: expiresTime,
      domain: domain,
      path: '/'
    });
  }
}
/**
 * 删除 cookie
 * @param {string} name cookie的name
 * @param {string} domain cookie的域
 * @param {string} path cookie的path
 * @memberof module:cookie
 */


function delCookie(name) {
  var domain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '.fudao.qq.com';
  var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '/';

  if (isServer) {
    return;
  }

  document.cookie = "".concat(name, "=; expires=Mon, 26 Jul 1997 05:00:00 GMT; path=").concat(path || '/', "; ").concat(domain ? "domain=".concat(domain, ";") : ''); // 安卓 APP 存在写入 Cookie 后关闭 WebView 失效的情况
  // 调用原生接口再写一次

  if (window.mqq && window.mqq.android) {
    window.mqq.invoke('edu', 'setCookie', {
      key: name,
      value: '',
      expiresTime: 10,
      domain: domain,
      path: path
    });
  }
}

export { getCookie, getCookies, setCookie, delCookie };